import { Component } from '@angular/core';
import { ParameterService } from 'src/app/shared/service/params/param';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrl: './public-header.component.scss'
})
export class PublicHeaderComponent {



  constructor(
    private paramService: ParameterService,

  ) {

  }
  configMairie: any = {};

  logo:any;
  commune:any;
  ngOnInit() {

    this.getLogoNomCommune();
  }


  getLogoNomCommune() {

    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
       // console.log("le logo du webservice", response);
        this.configMairie = response.data
          this.logo = this.configMairie?.logo?.value;
          this.commune = this.configMairie?.commune?.value;
      },
      (error: any) => {
      //  console.log("une erreur est survenu", error);

      }
    )
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../assets/new-accueil/logo.png';
  }
}

